import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { api } from '../../utils/api';
import { AdminSidebar } from '../../components/AdminSidebar';
import { Calendar, DollarSign, TrendingUp, XCircle } from 'lucide-react';

export const AdminDashboard = () => {
  const { token } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const data = await api.get('/api/admin/dashboard/stats', token);
      setStats(data);
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-background" data-testid="admin-dashboard-page">
      <AdminSidebar />
      
      <div className="flex-1 p-8">
        <h1 className="text-4xl font-display font-bold text-primary mb-8">
          Dashboard
        </h1>

        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-lg" data-testid="stat-bookings">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-text-secondary font-medium">Reservas do Mês</h3>
                <Calendar className="h-8 w-8 text-primary" />
              </div>
              <p className="text-3xl font-bold text-primary">
                {stats?.total_bookings_month || 0}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg" data-testid="stat-revenue">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-text-secondary font-medium">Receita do Mês</h3>
                <DollarSign className="h-8 w-8 text-green-600" />
              </div>
              <p className="text-3xl font-bold text-green-600">
                R$ {stats?.total_revenue_month?.toFixed(2) || '0.00'}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg" data-testid="stat-occupancy">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-text-secondary font-medium">Taxa de Ocupação</h3>
                <TrendingUp className="h-8 w-8 text-blue-600" />
              </div>
              <p className="text-3xl font-bold text-blue-600">
                {stats?.occupancy_rate?.toFixed(1) || 0}%
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg" data-testid="stat-cancellations">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-text-secondary font-medium">Cancelamentos</h3>
                <XCircle className="h-8 w-8 text-red-600" />
              </div>
              <p className="text-3xl font-bold text-red-600">
                {stats?.cancellations_month || 0}
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg col-span-full" data-testid="stat-pending">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-text-secondary font-medium mb-1">Reservas Pendentes de Pagamento</h3>
                  <p className="text-4xl font-bold text-yellow-600">
                    {stats?.pending_bookings || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
